// Third Party Imports
import { Component, EventEmitter, Input, Output } from '@angular/core';

// Models
import { SearchSettings } from '../../models';

@Component({
  selector: 'app-client-search',
  templateUrl: './client-search.component.html',
  styleUrls: ['./client-search.component.css']
})
export class ClientSearchComponent {
  @Input() placeholder: string;
  @Input() id = 'search';
  @Input() data: any[];
  @Input() settings: SearchSettings[];
  @Output() filter = new EventEmitter<any>();

  searchText = '';

  setSearchText(txt: string): void {
    this.searchText = txt;
  }

  onKeyUp(event: any): void {
    const val = event.target.value.toLowerCase();

    if (!val) {
      this.filter.emit(this.data);
    }

    const filtered = this.data.filter(row => {
      let result = false;

      this.settings.forEach(setting => {
        if (result === false && row[setting.fieldName]) {
          const transformedValue = setting.pipe ? setting.pipe.transform(row[setting.fieldName]) : row[setting.fieldName];

          if (transformedValue.toString().toLowerCase().indexOf(val) !== -1) {
            result = true;
          }
        }
      });

      return result;
    });

    this.filter.emit(filtered);
  }
}
